/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "f86ee7872c0b73e41fea640cc8d4aaac1307abbd";
